import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';
import { UserAccountComponent } from './user-account/user-account.component';
import { DeletionRequestsComponent } from './deletion-requests/deletion-requests.component';
import { BreadcrumbComponent, BreadcrumbItem } from '../../components/shared/breadcrumb/breadcrumb.component';

const TAB_SLUGS = ['userAccount', 'deletionRequests'] as const;

@Component({
  selector: 'app-settings-page',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatTabsModule,
    TranslocoModule,
    UserAccountComponent,
    DeletionRequestsComponent,
    BreadcrumbComponent
  ],
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.scss']
})
export class SettingsPageComponent {
  selectedIndex = 0;
  readonly tabs = TAB_SLUGS;

  get breadcrumbItems(): BreadcrumbItem[] {
    const items: BreadcrumbItem[] = [
      { labelKey: 'breadcrumbs.home', link: '/' },
      { labelKey: 'pages.settings.title', link: '/settings' },
    ];
    const slug = this.tabs[this.selectedIndex];
    if (slug) {
      items.push({ labelKey: 'pages.settings.tabs.' + slug });
    }
    return items;
  }

  onTabChange(index: number): void {
    this.selectedIndex = index;
  }

  onMobileSelectChange(value: string | number): void {
    const idx = typeof value === 'string' ? Number(value) : value;
    if (!Number.isNaN(idx)) this.onTabChange(idx);
  }
}